import React, { FunctionComponent } from 'react';
import { Icon, Label, Popup } from 'semantic-ui-react';
import { formatDateTime } from 'utils';
import { Review } from '../types/review.type';

type ReviewCheckerLabelProps = {
  review: Review;
  size?: 'mini' | 'small';
  onClick?: () => void;
};

export const ReviewCheckerLabel: FunctionComponent<ReviewCheckerLabelProps> = ({
  review,
  size = 'small',
  onClick,
}) => {
  if (
    !review.checker ||
    (review.status !== 'draft' && review.status !== 'ok')
  ) {
    return null;
  }

  const isChecked = review.status === 'ok';
  const checkerName = `${review.checker.givenName} ${review.checker.familyName}`;
  const color = isChecked ? 'green' : 'orange';
  const icon = isChecked ? 'clipboard check' : 'exclamation triangle';
  const text = isChecked ? 'Avis vérifié' : 'Avis en cours de vérification';

  if (size === 'mini') {
    return (
      <Popup
        content={`${text} (${checkerName})`}
        trigger={
          <Label color={color} size="small" basic={isChecked}>
            <Icon fitted name={icon} />
          </Label>
        }
      />
    );
  }

  return (
    <Popup
      content={
        <p style={{ textAlign: 'center' }}>
          Demande de vérification effectuée le :
          <br />
          <strong>
            {review.checkDate ? formatDateTime(review.checkDate) : null}
          </strong>
        </p>
      }
      position="top center"
      trigger={
        <Label as="a" size="small" onClick={onClick} color={color}>
          <Icon name={icon} />
          {text} ({checkerName})
        </Label>
      }
    />
  );
};
